import AccordionItem from '@common/ui/accordion/AccordionItem';
import { calculateDateforJP } from '@utils/stringUtils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const AftercareDetail = (props) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const renderTitle = (data) => (React.createElement("div", { className: "row orders-listing__order-detail" },
        React.createElement("div", { className: "col-12 col-lg-8 order-detail__column" },
            React.createElement("h2", null,
                React.createElement("span", { className: "dt" }, t('aftercare.requestno')),
                React.createElement("span", { className: "dd" }, data.code))),
        React.createElement("p", { className: "col-12 col-lg-8 order-detail__column" },
            React.createElement("span", { className: "dt" }, t('label.date')),
            React.createElement("span", { className: "dd" }, calculateDateforJP(data.created))),
        React.createElement("p", { className: "col-12 col-lg-8 order-detail__column" },
            React.createElement("span", { className: "dt" }, t('order.status')),
            React.createElement("span", { className: "dd" }, data.status))));
    return (React.createElement(React.Fragment, null,
        React.createElement(AccordionItem, { expanded: isOpen, onSelect: () => {
                setIsOpen(!isOpen);
            }, title: renderTitle(props.aftercare), accordionId: String(props.aftercare.code), isTitleMarkup: true, itemClass: "orders-listing__order", headerClass: "accordion__header--cta-hidden", hideToggleButtons: true })));
};
export default AftercareDetail;
